import * as THREE from 'three';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js'
import { VRMLLoader } from 'three/examples/jsm/loaders/VRMLLoader.js';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { FikoVektor3D } from '../FikoVektor3d';
import { fikoObjeyiStepIndir, fikoStepAyarlariniDuzenle } from './FikoSTEPDisaAktar';


export class FikoCizimWRL extends FikoGrup {
    override type: any = "FikoCizimWRL";
    /** */
    sayac = 1;

    override komutlar = [
        {
            isim: "Gizle / Göster",
            simge: "eye",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.ciz();
            }
        }
        ,
        {
            isim: "Ekrana Sığdır",
            simge: "face",
            tiklandi: () => {
                this.sahne.ekranaSigdir(this);
            }
        }
        ,
        {
            isim: "STEP olarak indir (B-Rep)",
            simge: "download",
            tiklandi: async () => {
                try { await fikoObjeyiStepIndir(this, 'brep', this.name); }
                catch (e: any) {
                    console.error('STEP (B-Rep) disa aktarim hatasi', e);
                    alert('STEP olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        }
        ,
        {
            isim: "STEP olarak indir (AP242 Tessellated)",
            simge: "download",
            tiklandi: async () => {
                try { await fikoObjeyiStepIndir(this, 'tessellated', this.name); }
                catch (e: any) {
                    console.error('STEP (Tessellated) disa aktarim hatasi', e);
                    alert('STEP olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        }
        ,
        {
            isim: "STEP ayarları...",
            simge: "cog",
            tiklandi: () => { fikoStepAyarlariniDuzenle(); }
        }
    ]

    public override get liste(): any[] {
        return this.children;
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/wrl.webp";
    }

    /**
     *
     */
    mergedNoktalar: THREE.BufferGeometry;
    mergedCizgiler: THREE.BufferGeometry;
    mergedCizgiNoktalari: THREE.BufferGeometry;
    mergedYuzeyler: THREE.BufferGeometry;

    async grupCozumle(grup: any) {
        let noktalar = new THREE.Points(); //new FikoGrup(this.sahne, "noktalar");
        let cizgiler = new THREE.LineSegments //new FikoGrup(this.sahne, "cizgiler");
        let bulut = new THREE.Mesh() //new FikoGrup(this.sahne, "bulut");

        let toplanmisNoktalar: THREE.BufferGeometry[] = [];
        let toplanmisCizgiler: THREE.BufferGeometry[] = [];
        let toplanmisCizgiNoktalari: THREE.BufferGeometry[] = [];
        let toplanmisYuzeyler: THREE.BufferGeometry[] = [];

        let grpi = 0;
        let strti = 0;
        let grplinei = 0;
        let strtlinei = 0;
        for (let i = 0; i < grup.children.length; i++) {
            const element = grup.children[i];
            if (element.type == "Points") {
                const e = element as THREE.Points;
                toplanmisNoktalar.push(e.geometry.clone());
            }
            if (element.type == "LineSegments") {
                const e = element as THREE.LineSegments;
                const mat = e.material as THREE.LineBasicMaterial;
                let renkler: any[] = [];
                let seffaflik: any[] = [];
                let grup: any[] = [];
                for (let i = 0; i < e.geometry.attributes['position'].count; i++) {
                    renkler.push(...[mat.color.clone().r, mat.color.clone().g, mat.color.clone().b])
                    seffaflik.push(mat.opacity);
                    grup.push(...[strtlinei, e.geometry.attributes['position'].count, grplinei])
                }
                e.geometry.setAttribute("color", new THREE.Float32BufferAttribute(renkler, 3));
                // e.geometry.setAttribute("orjinalRenkler", new THREE.Float32BufferAttribute(renkler, 3));
                e.geometry.setAttribute("alpha", new THREE.Float32BufferAttribute(seffaflik, 1));
                e.geometry.setAttribute("grup", new THREE.Float32BufferAttribute(grup, 3));

                toplanmisCizgiler.push(e.geometry.clone());
                grplinei++
                strtlinei += e.geometry.attributes['position'].count;
                /** */
                /** */
                let array = (element as THREE.LineSegments).geometry.clone().attributes['position'].array;
                let point1: FikoVektor3D = (element as THREE.LineSegments).localToWorld(new FikoVektor3D(array[0], array[1], array[2]));
                let point2: FikoVektor3D = (element as THREE.LineSegments).localToWorld(new FikoVektor3D(array[array.length - 3], array[array.length - 2], array[array.length - 1]));
                toplanmisCizgiNoktalari.push(new THREE.BufferGeometry().setFromPoints([point1, point2]));
            }
            if (element.type == "Mesh") {
                const e = element as THREE.Mesh;
                const mat = e.material as THREE.MeshPhongMaterial;
                let renkler: any[] = [];
                let seffaflik: any[] = [];
                let grup: any[] = [];

                for (let i = 0; i < e.geometry.attributes['position'].count; i++) {
                    renkler.push(...[mat.color.clone().r, mat.color.clone().g, mat.color.clone().b])
                    seffaflik.push(mat.opacity);
                    grup.push(...[strti, e.geometry.attributes['position'].count, grpi])
                }
                e.geometry.setAttribute("color", new THREE.Float32BufferAttribute(renkler, 3));
                // e.geometry.setAttribute("orjinalRenkler", new THREE.Float32BufferAttribute(renkler, 3));
                e.geometry.setAttribute("alpha", new THREE.Float32BufferAttribute(seffaflik, 1));
                e.geometry.setAttribute("grup", new THREE.Float32BufferAttribute(grup, 3));

                toplanmisYuzeyler.push(e.geometry.clone());
                grpi++
                strti += e.geometry.attributes['position'].count;
            }
        }

        if (toplanmisNoktalar.length > 0) {
            this.mergedNoktalar = BufferGeometryUtils.mergeGeometries(toplanmisNoktalar);
            noktalar = new THREE.Points(this.mergedNoktalar, this.sahne.anaGosterim.standartMaterialPointVertex);
        }
        if (toplanmisCizgiNoktalari.length > 0) {
            this.mergedCizgiNoktalari = BufferGeometryUtils.mergeGeometries(toplanmisCizgiNoktalari);
            noktalar = new THREE.Points(this.mergedCizgiNoktalari, this.sahne.anaGosterim.standartMaterialPointVertex);
        }
        if (toplanmisCizgiler.length > 0) {
            this.mergedCizgiler = BufferGeometryUtils.mergeGeometries(toplanmisCizgiler)
            cizgiler = new THREE.LineSegments(this.mergedCizgiler, this.sahne.anaGosterim.standartMaterialCizgiEdge);
        }
        if (toplanmisYuzeyler.length > 0) {
            this.mergedYuzeyler = BufferGeometryUtils.mergeGeometries(toplanmisYuzeyler);
            // bulut.ekle(new THREE.Mesh(this.mergedYuzeyler, new THREE.MeshPhongMaterial({ vertexColors: true, dithering: true, side: THREE.DoubleSide, polygonOffset: true, polygonOffsetFactor: 1, polygonOffsetUnits: 1, premultipliedAlpha: true, alphaTest: 0.1, transparent: true })))
            bulut = new THREE.Mesh(this.mergedYuzeyler, this.sahne.anaGosterim.standartMaterialMesh)
        }

        // let topolojiNoktalar: THREE.Points = new THREE.Points(BufferGeometryUtils.mergeGeometries(cizgilerGeom), new THREE.PointsMaterial({ size: 5 }));
        const toplananGrup: FikoGrup = new FikoGrup(this.sahne, "body");
        toplananGrup.userData['FikoArayuz'].agactaGorunur = true;
        toplananGrup.userData['FikoArayuz'].listeGoster = true;

        bulut.userData['kokObje'] = toplananGrup;
        cizgiler.userData['kokObje'] = toplananGrup;
        noktalar.userData['kokObje'] = toplananGrup;

        // bulut.userData.FikoArayuz={};
        // bulut.userData.FikoArayuz.agactaGorunur = true;
        // cizgiler.userData.FikoArayuz={};
        // cizgiler.userData.FikoArayuz.agactaGorunur = true;
        // noktalar.userData.FikoArayuz={};
        // noktalar.userData.FikoArayuz.agactaGorunur = true;


        toplananGrup.komutlar = [
            {
                baslik: "Gizle / Göster",
                simge: "eye",
                tiklandi: () => {
                    toplananGrup.visible = !toplananGrup.visible;
                    toplananGrup.sahne.anaGosterim.ciz();
                }
            },
        ]

        // console.log(this.toJSON())
        toplananGrup.ekle(noktalar, cizgiler, bulut)
        return toplananGrup;

    }

    urlden(url: any) {

        let _this = this;


        const loader: VRMLLoader = new VRMLLoader();

        loader.loadAsync(url).then(function (scene: THREE.Scene) {
            scene.remove(scene.children[0]);
            scene.traverse(async (elm: any) => {

                if (elm != undefined && elm.type == "Group" && elm?.name != "" && elm?.children?.length > 0) {
                    _this.ekle(await _this.grupCozumle(elm))

                }
            });

            for (var i = scene.children.length - 1; i >= 0; i--) {
                let obj = scene.children[i];
                scene.remove(obj);
            }

            _this.sahne?.anaGosterim?.ciz()
            _this.sahne?.anaGosterim?.FikoYT.degisti.emit();
        });

    }

    dosyadan(dosya: any) {

        let _this = this;


        const loader: VRMLLoader = new VRMLLoader();

        loader.loadAsync(URL.createObjectURL(dosya)).then(function (scene: THREE.Scene) {
            scene.remove(scene.children[0]);
            scene.traverse(async (elm: any) => {

                if (elm != undefined && elm.type == "Group" && elm?.name != "" && elm?.children?.length > 0) {
                    _this.ekle(await _this.grupCozumle(elm))

                }
            });

            for (var i = scene.children.length - 1; i >= 0; i--) {
                let obj = scene.children[i];
                scene.remove(obj);
            }

            _this.sahne?.anaGosterim?.ciz()
            _this.sahne?.anaGosterim?.FikoYT.degisti.emit();
        });

    }

    kayittan(kayitString: string) {
        let _this = this;
        const loader: VRMLLoader = new VRMLLoader();
        const scene = loader.parse(kayitString, null);

        scene.remove(scene.children[0]);
        scene.traverse(async (elm: any) => {

            if (elm != undefined && elm.type == "Group" && elm?.name != "" && elm?.children?.length > 0) {
                _this.ekle(await _this.grupCozumle(elm))
            }
        });

        for (var i = scene.children.length - 1; i >= 0; i--) {
            let obj = scene.children[i];
            scene.remove(obj);
        }

        _this.sahne?.anaGosterim?.ciz()
        _this.sahne?.anaGosterim?.FikoYT.degisti.emit();
    }

    override raycast(raycaster: THREE.Raycaster, intersects: THREE.Intersection[]): void {
        let kesisenler = raycaster.intersectObjects(this.children, true);

        kesisenler.forEach((elm: any) => {
            elm.grup = this;
        })

        intersects.push(...kesisenler);

        // if (kesisenler.length > 0) {
        //     intersects.push({
        //         object: this,
        //         // distance: 0,
        //         point: null,
        //         face: null,
        //         faceIndex: null,
        //         index: null,
        //         instanceId: this.id,
        //         //@ts-ignore
        //         // yon: { x: this.xYon, y: this.yYon, z: this.zYon },
        //         altObje: kesisenler[0].object,
        //     });

        // } else {
        //     return;
        // }
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        let yuzeyler = this.mergedYuzeyler.toJSON();
        delete yuzeyler.userData
        let cizgiler = this.mergedCizgiler.toJSON();
        delete cizgiler.userData

        return {
            name: this.name,
            uuid: this.uuid,
            type: this.type,
            visible: this.visible,
            matrix: this.matrix.toArray(),
            userData: this._serializeUserData(),
            geometry: {
                yuzeyler: yuzeyler,
                cizgiler: cizgiler
            }
        }
    }
}